var render = function render(_c,_vm){return _c('div',{staticClass:"flex justify-between items-center w-full p-8 mb-4 rounded bg-grey-300 opacity-50"},[_c('p',{staticClass:"text-lg text-black"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }